import axios from 'axios';
import { environment } from '../environments/environment';

import { sortFilters } from '../utils/FilterSettings';
import { Filters, Option } from '../utils/pageConfig/Types';
import { ProductDataType, ProductType } from '../pages/product-analyzer/Product';

type ProductFeaturesParam = {
  clientId: number;
  productType: ProductType;
  country: string;
  periodType: string;
  productGroup: string;
  dataType: string;
  feature: string;
  featureValue: Option[];
};

/*
 * function that gets the feature values/filter & filter options based on retailer+country+periodType+PG
 */
export const getProductFeatures = async (param: ProductFeaturesParam): Promise<Filters[]> => {
  const { clientId, productType, country, periodType, productGroup, dataType, feature, featureValue } = param;

  try {
    const featValue: string[] = featureValue.map((f: { value: any }) => {
      return f.value;
    });

    let { data } = await axios.post<Filters[]>(`${environment.baseUrl}/v2/filters/product-features`, {
      clientId: clientId,
      productType: productType,
      productDataType: ProductDataType.PerformanceAnalyzer,
      country: [country.toUpperCase()],
      periodType: periodType.toUpperCase(),
      productGroup: [productGroup.toUpperCase()],
      segmentByDataType: dataType.toUpperCase(),
      feature: feature.toUpperCase(),
      featureValue: featValue,
    });
    data = sortFilters(data);
    // eslint-disable-next-line array-callback-return
    data.map((filter) => {
      const index = [...filter.options].findIndex((o) => o.label === 'TOTAL');

      if (index !== -1) {
        filter.options.splice(index, 1);
      }
    });
    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};
